import Get from '../services/Get';
import Post from '../services/Post';

import { nexcareVersion } from '../config/serviceConfig';

const getCommissionByCSLevel = (filter, token) => Get(`/${nexcareVersion}/nexcare/commission?page=1&limit=100&filter=cs_level eq ${filter}`, token);
const postCommissionScheme = (data, token) => Post(`/${nexcareVersion}/nexcare/commission`, data, token);
const getLevelCSList = (token) => Get(`/${nexcareVersion}/nexcare/commission/remark/cs-level?page=1&limit=100`, token);

const API_COMMISSION_SCHEME = {
    getCommissionByCSLevel,
    postCommissionScheme,
    getLevelCSList,
}

export default API_COMMISSION_SCHEME;